<template>
  <q-page class="q-px-md">
    <h1 class="text-h5">Integrations</h1>
    <Integrations :account-id="accountId" />
  </q-page>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Integrations from '@/iam/integration/Integrations.vue';

interface Data {
  accountType: number
}

export default defineComponent({
  meta: {
    title: 'Integrations',
  },
  components: {
    Integrations,
  },
  props: {
    accountId: {
      type: Number,
      required: true,
    },
  },
});
</script>
